import { render } from "./ProposalContent.vue?vue&type=template&id=3704b674&scoped=true&ts=true"
import script from "./ProposalContent.vue?vue&type=script&lang=ts"
export * from "./ProposalContent.vue?vue&type=script&lang=ts"

import "./ProposalContent.vue?vue&type=style&index=0&id=3704b674&scoped=true&lang=scss"

import exportComponent from "/opt/apps/parcel4you-web-staging/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3704b674"]])

export default __exports__